module.exports = "<p data-bind=\"safeHtml: text\"></p>\r\n"
window.define('text!flow/viewModels/ConfirmDialog.html', [], function() { return __webpack_module__.exports; });